<img
  *ngIf="imageId"
  src="{{ baseUrl + '/files/download/img/' + imageId }}"
  [alt]="alt || ''"
/>
<span>{{ name }}</span>
